import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'additional-front-user-info-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AdditionalFrontUserInfoFormDialogComponent implements OnInit {
  public formGroup: FormGroup = new FormGroup({
    title: new FormControl('', Validators.required),
    active: new FormControl(true),
    showOnTable: new FormControl(false),
    columnName: new FormControl('', Validators.maxLength(45))
  });
  action: string;
  dialogTitle: string;
  item: any;

  constructor(
    public dialogRef: MatDialogRef<AdditionalFrontUserInfoFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.action = data?.action;

    if (this.action === 'edit') {
      this.dialogTitle = 'additionalFrontUserInfo.edit';
      this.item = data.item || data.type || data.data || data;
    } else {
      this.dialogTitle = 'additionalFrontUserInfo.new';
    }
  }

  ngOnInit() {
    if (this.action === 'edit' && this.item) {
      this.formGroup.patchValue(this.item);
    }
  }
}
